//region block: pre-declaration
//endregion
function revokeObjectURL(url) {
  URL.revokeObjectURL(url);
}
function createObjectURLBlob(blob) {
  return URL.createObjectURL(blob);
}
function createObjectURLFileReference(fileReference) {
  return URL.createObjectURL(fileReference);
}
//region block: exports
export {
  createObjectURLFileReference as createObjectURLFileReference3o8golj1mnrvr,
  createObjectURLBlob as createObjectURLBlob28c4i1stg1nh2,
  revokeObjectURL as revokeObjectURLfycm7e1b77ci,
};
//endregion

//# sourceMappingURL=ImageView.commonHtml.js.mjs.map
